module.exports = __webpack_public_path__ + "img/wolfcard_1.8f60cbad.png";